// /src/components/chat/shared/DragHandle.js
import React from 'react';
import { Box } from '@mui/material';

const DragHandle = ({ sidebarWidth, setSidebarWidth }) => {
  const startDragging = (e) => {
    const startX = e.clientX;
    const startWidth = sidebarWidth;

    const doDrag = (e) => {
      const newWidth = Math.min(Math.max(200, startWidth + e.clientX - startX), 600);
      setSidebarWidth(newWidth);
    };

    const stopDrag = () => {
      document.removeEventListener('mousemove', doDrag);
      document.removeEventListener('mouseup', stopDrag);
    };

    document.addEventListener('mousemove', doDrag);
    document.addEventListener('mouseup', stopDrag);
  };

  return (
    <Box
      sx={{
        width: '5px',
        cursor: 'col-resize',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        zIndex: 10,
      }}
      onMouseDown={startDragging}
    />
  );
};

export default DragHandle;
